import { useDynamicEntity } from './useDynamicEntity';
import { useAuth } from './index';

const useReportTypes = () => {
  const { user } = useAuth();

  const dynamicHook = useDynamicEntity({
    entityType: 'reportTypes',
    gqlEntityKey: 'report_types',
    queryName: 'GET_REPORT_TYPES_QUERY',
    createMutation: 'CREATE_REPORT_TYPE_MUTATION',
    updateMutation: 'UPDATE_REPORT_TYPE_MUTATION',
    deleteMutation: 'DELETE_REPORT_TYPE_MUTATION',
    updateVariableName: 'set',
    transformData: (reportType) => {
      const rawTags = reportType.report_type_tags || [];
      const tags = rawTags.map((t) => (typeof t === 'string' ? t : t?.name ?? String(t)));
      return {
        ...reportType,
        company_name: reportType.company?.name || `Company ${reportType.company_id}`,
        report_type_name: reportType.report_type_name,
        report_type_description: reportType.report_type_description,
        report_type_status: reportType.report_type_status ? 'active' : 'inactive',
        companyId: reportType.company_id,
        tags,
        report_type_tags: tags,
      };
    },
    transformFormData: (formData) => ({
      report_type_name: formData.report_type_name,
      report_type_description: formData.report_type_description || null,
      report_type_status: formData.report_type_status === 'active',
      report_type_tags: Array.isArray(formData.report_type_tags) ? formData.report_type_tags : [],
    }),
    customWhereCondition: user?.role === 'ROOT' ? {} : { company_id: { _eq: user?.companyId } },
  });
  return {
    ...dynamicHook,
    isRootUser: user?.role === 'ROOT',
  };
};

export { useReportTypes };
